var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import ChainRouter from '@popup/multichain/chain-router.component';
import { Chain, ChainContext } from '@popup/multichain/multichain.context';
import { store } from '@popup/multichain/store';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import React, { useCallback, useEffect, useState } from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { Provider } from 'react-redux';
import { ErrorFallback } from 'src/common-ui/error-fallback/error-fallback.component';
import { Theme, ThemeContext } from 'src/popup/theme.context';
import LocalStorageUtils from 'src/utils/localStorage.utils';
export const MultichainContainer = () => {
    const [chain, setChain] = useState();
    const [theme, setTheme] = useState();
    const [ready, setReady] = useState(false);
    useEffect(() => {
        init();
    }, []);
    const handleKeyPress = useCallback((event) => {
        if (event.ctrlKey && event.altKey && event.code === 'KeyT') {
            setTheme((previous) => {
                return previous === Theme.LIGHT ? Theme.DARK : Theme.LIGHT;
            });
        }
        if (event.key === 'd' && event.ctrlKey) {
            handleDetachWindow();
        }
    }, []);
    useEffect(() => {
        // remove the event listener
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [handleKeyPress]);
    const handleDetachWindow = () => {
        chrome.tabs.create({
            url: `detached_window.html`,
        });
    };
    const init = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const res = yield LocalStorageUtils.getMultipleValueFromLocalStorage([
            LocalStorageKeyEnum.ACTIVE_THEME,
            LocalStorageKeyEnum.ACTIVE_CHAIN,
        ]);
        setTheme((_a = res.ACTIVE_THEME) !== null && _a !== void 0 ? _a : Theme.LIGHT);
        setChain((_b = res.ACTIVE_CHAIN) !== null && _b !== void 0 ? _b : Chain.STEEM);
        setReady(true);
        // attach the event listener
        document.addEventListener('keydown', handleKeyPress);
    });
    useEffect(() => {
        const saveChain = () => __awaiter(void 0, void 0, void 0, function* () {
            if (chain) {
                yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.ACTIVE_CHAIN, chain);
            }
        });
        saveChain();
    }, [chain]);
    useEffect(() => {
        const saveTheme = () => __awaiter(void 0, void 0, void 0, function* () {
            if (theme) {
                yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.ACTIVE_THEME, theme);
            }
        });
        saveTheme();
    }, [theme]);
    const toggleTheme = () => {
        setTheme((oldTheme) => {
            return oldTheme === Theme.DARK ? Theme.LIGHT : Theme.DARK;
        });
    };
    return (React.createElement(React.Fragment, null, ready && theme && (React.createElement(ThemeContext.Provider, { value: { theme, setTheme, toggleTheme } },
        React.createElement(ChainContext.Provider, { value: { chain, setChain } },
            React.createElement("div", { className: `theme ${theme}` },
                React.createElement(ChainComponentWithBoundary, { theme: theme, chain: chain })))))));
};
const ChainComponent = ({ chain }) => {
    return (React.createElement(Provider, { store: store }, React.createElement(ChainRouter, { screen: screen, selectedChain: chain })));
};
const ChainComponentWithBoundary = withErrorBoundary(ChainComponent, {
    FallbackComponent: ErrorFallback,
});
